<script>
  import { onDestroy, onMount } from "svelte";
  import Conexoes from "../../Classes/Conexoes";
  import Constantes from "../../Classes/Constantes";

  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";

  const conexao = new Conexoes();
  let dados = [];
  let isLoading;
  let intervalId;
  async function pegaDados() {
    //  isLoading = true;
    dados = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: "tela_em_branco",
    });
    console.log("dado", dados);
    // isLoading=false;
  }

  // Função que define o intervalo
  function iniciarIntervalo() {
    // Chama a função a cada 13 segundos (13000 milissegundos)
    pegaDados();
    intervalId = setInterval(() => {
      pegaDados();
    }, 13000);
  }

  // Executa a função quando o componente é montado
  onMount(() => {
    iniciarIntervalo();
  });

  // Limpa o intervalo quando o componente for destruído
  onDestroy(() => {
    clearInterval(intervalId);
  });

  let nivel = "";
</script>

<LoadingTela {isLoading} />

<!-- Combobox (Dropdown) -->
<div class="bordaQuesitos" style="margin-top: 70px; margin-left: 20px; margin-right: 20px; margin-bottom: 100px;">
  <label for="nivel">Ranking :</label>
  <select id="nivel" bind:value={nivel}>
    <option value="">Selecione a Categoria</option>
    <option value="scaleF">Scaled Feminino</option>
    <option value="scaleM">Scaled Masculino</option>
    <option value="interF">Intermediário Feminino</option>
    <option value="interM">Intermediário Masculino</option>
    <option value="master">Master 35+ Masculino</option>
    <option value="rxF">RX Feminino</option>
    <option value="rxM">RX Masculino</option>
  </select>

  {#if dados.length > 0}
    <!-- Conteúdo Condicional -->
    {#if nivel === "scaleF"}
      <div>
        {@html dados[0].html1}
      </div>
    {:else if nivel === "scaleM"}
      <div>
        {@html dados[0].html2}
      </div>
    {:else if nivel === "interF"}
      <div>
        {@html dados[0].html3}
      </div>
    {:else if nivel === "interM"}
      <div>
        {@html dados[0].html4}
      </div>
    {:else if nivel === "master"}
      <div>
        {@html dados[0].html5}
      </div>
    {:else if nivel === "rxF"}
      <div>
        {@html dados[0].html6}
      </div>
    {:else if nivel === "rxM"}
      <div>
        {@html dados[0].html7}
      </div>
    {/if}
  {/if}
</div>



<style>
  .bordaQuesitos {
    border: 1px solid #ccc; /* Define a borda com 2px de largura e cor preta */
    border-radius: 5px; /* Define o arredondamento dos cantos */
    padding: 10px; /* Adiciona um preenchimento interno à div */
  }

  select {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    transition:
      border-color 0.3s,
      box-shadow 0.3s;
  }

</style>